export default "__VITE_ASSET__CA1_8Ej7__"